import styled from '@emotion/styled'

export const UserDetailContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
`

export const UserAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
`

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`

export const UserName = styled.p`
  font-weight: 300;
  margin: 0;
`

export const UserGender = styled.p`
  margin: 0;
  font-size: 12px;
`

export const DateTimeContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const DateText = styled.p`
  margin: 0;
`

export const TimeText = styled.p`
  margin: 0;
  font-size: 12px;
  color: #888;
`
